import { createVNode, render } from 'vue'
import TwoFactorModal from './components/TwoFactorModal.vue'

/**
 * Affiche la modale 2FA programmatique
 * @param {object} options
 * @param {boolean} options.isSetup
 * @param {string} [options.qrUrl]
 * @param {string} [options.secretKey]
 * @param {(secretotp: string) => Promise<{ success: boolean, message?: string }>} options.onVerify
 * @returns {Promise<{ success: boolean, cancelled?: boolean, result?: any }>}
 */
export function showTwoFactorPrompt(options) {
  return new Promise(resolve => {
    const container = document.createElement('div')
    document.body.appendChild(container)

    const cleanup = () => {
      render(null, container)
      container.remove()
    }

    const vnode = createVNode(TwoFactorModal, {
      ...options,
      onSuccess: result => {
        cleanup()
        resolve({ success: true, result })
      },
      onCancel: () => {
        cleanup()
        resolve({ success: false, cancelled: true })
      },
    })

    render(vnode, container)
  })
}

export default showTwoFactorPrompt
